import styled from 'styled-components';
import Colours from '../../../design-system/colours';

const OvRecordDetailsPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.375rem;
  margin-left: 1rem;
  min-width: 0;
  color: ${Colours.OV_BASE};
`;

export default OvRecordDetailsPage;
